export const Badge = ({ children, className = "bg-blue-100 text-blue-800" }) => (
  <span className={`inline-block px-2 py-1 rounded text-sm ${className}`}>
    {children}
  </span>
);
